__webpack_require__.p = "/apps/collectives/js/";